import React, { useState } from 'react';
import contactImg from '../img/contact.png'

const axios = require('axios').default;

function Contact() {
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [comments, setComments] = useState('')
  const [success, setSuccess] = useState(false)
  const [failure, setFailure] = useState(false)
  const [validationError, setValidationError] = useState(false)
  const [validationMessage, setValidationMessage] = useState('')

  // Email address verification, do not edit.
  const isEmail = (email) => {
    const regex = /^[-_.[:alnum:]]+@((([[:alnum:]]|[[:alnum:]][[:alnum:]-]*[[:alnum:]])\.)+(ad|ae|aero|af|ag|ai|al|am|an|ao|aq|ar|arpa|as|at|au|aw|az|ba|bb|bd|be|bf|bg|bh|bi|biz|bj|bm|bn|bo|br|bs|bt|bv|bw|by|bz|ca|cc|cd|cf|cg|ch|ci|ck|cl|cm|cn|co|com|coop|cr|cs|cu|cv|cx|cy|cz|de|dj|dk|dm|do|dz|ec|edu|ee|eg|eh|er|es|et|eu|fi|fj|fk|fm|fo|fr|ga|gb|gd|ge|gf|gh|gi|gl|gm|gn|gov|gp|gq|gr|gs|gt|gu|gw|gy|hk|hm|hn|hr|ht|hu|id|ie|il|in|info|int|io|iq|ir|is|it|jm|jo|jp|ke|kg|kh|ki|km|kn|kp|kr|kw|ky|kz|la|lb|lc|li|lk|lr|ls|lt|lu|lv|ly|ma|mc|md|me|mg|mh|mil|mk|ml|mm|mn|mo|mp|mq|mr|ms|mt|mu|museum|mv|mw|mx|my|mz|na|name|nc|ne|net|nf|ng|ni|nl|no|np|nr|nt|nu|nz|om|org|pa|pe|pf|pg|ph|pk|pl|pm|pn|pr|pro|ps|pt|pw|py|qa|re|ro|ru|rw|sa|sb|sc|sd|se|sg|sh|si|sj|sk|sl|sm|sn|so|sr|st|su|sv|sy|sz|tc|td|tf|tg|th|tj|tk|tm|tn|to|tp|tr|tt|tv|tw|tz|ua|ug|uk|um|us|uy|uz|va|vc|ve|vg|vi|vn|vu|wf|ws|ye|yt|yu|za|zm|zw)$|(([0-9][0-9]?|[0-1][0-9][0-9]|[2][0-4][0-9]|[2][5][0-5])\.){3}([0-9][0-9]?|[0-1][0-9][0-9]|[2][0-4][0-9]|[2][5][0-5]))$/i;
    const isMatch = email.match(regex);
    console.log(isMatch)
    return(isMatch); // TODO: now returning null
  }

  // Copied here https://coursesweb.net/javascript/strip_tags-stripslashes-javascript_cs
  // Replaces stripslashes
  const strip_tags = (str, allow) => {
    // making sure the allow arg is a string containing only tags in lowercase (<a><b><c>)
    allow = (((allow || '') + '').toLowerCase().match(/<[a-z][a-z0-9]*>/g) || []).join('');
   
    var tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi;
    var commentsAndPhpTags = /<!--[\s\S]*?-->|<\?(?:php)?[\s\S]*?\?>/gi;
    return str.replace(commentsAndPhpTags, '').replace(tags, function ($0, $1) {
    return allow.indexOf('<' + $1.toLowerCase() + '>') > -1 ? $0 :'';
    });
   }

  // Submit form
  let handleSubmit = async (e) => {
    e.preventDefault();

    // Remove success or failure
    setFailure(false);
    setSuccess(false);

    // Add validation
    if(name.trim() === '') {
      setValidationError(true);
      setValidationMessage('Please enter your name.');
      return;
    } else if(email.trim() === '') {
      setValidationError(true);
      setValidationMessage('Please enter your email address.');
      return;
    // } else if(!isEmail(email)) {
    //   setValidationError(true);
    //   setValidationMessage('You must enter a valid email address.');
    //   return;
    } else if(phone.trim() === '') {
      setValidationError(true);
      setValidationMessage('Please enter your phone number.');
      return;
    }
    else if(comments.trim() === '') {
      setValidationError(true);
      setValidationMessage('Please enter the reason why you are contacting us.');
      return;
    }

    // Submit request
    try {
      axios.post('/prod/email', {
        name: name,
        email: email,
        phone: phone,
        desc: comments
      })
      .then(function (res) {
        //let resJson = await res.json();
        if (res.status === 200) {
          setName("");
          setEmail("");
          setPhone("");
          setComments("");
          setSuccess(true);
        }
      })
      .catch(function (err) {
        setFailure(true);
      });
    } catch (err) {
      setFailure(true);
      console.log(err);
    }
  };

  const handleChange = (e) => {
    const value = e.target.value;

    switch(e.target.id) {
      case 'name':
        setName(value)
        break;
      case 'email':
        setEmail(value)
        break;
      case 'phone':
        setPhone(value)
        break;
      case 'comments':
        setComments(strip_tags(value, '<b><i><u>'))
        break;
      default:
        // code block
    }

    // Reset validation messages
    if (success) {
      setSuccess(false);
    }
    if (failure) {
      setFailure(false);
    }
    if (validationError) {
      setValidationError(false);
      setValidationMessage('');
    }
  }

  return (
    <>
    <div className="breadcrumb-area gradient-bg bg-cover shadow dark text-light text-center" style={{backgroundImage: `url(${contactImg})`}}>
        <div className="container">
            <div className="row">
                <div className="col-lg-8 offset-lg-2">
                    <h1>Contact Us</h1>
                    <ul className="breadcrumb">
                        <li><a href="#"><i className="fas fa-home"></i> Home</a></li>
                        <li className="active">Contact</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div className="contact-area default-padding">
        <div className="container">
            <div className="contact-items">
                <div className="row">
                    
                    <div className="col-lg-8 left-item">
                        <div className="content">
                            <h2>Contact our <strong>Support Office</strong></h2>
                            <form onSubmit={handleSubmit} className="contact-form">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="form-group">
                                            <input className="form-control" id="name" name="name" value={name} onChange={(e) => handleChange(e)} placeholder="Name" type="text" />
                                            <span className="alert-error"></span>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <input className="form-control" id="email" name="email" value={email} onChange={(e) => handleChange(e)} placeholder="Email*" type="email" />
                                            <span className="alert-error"></span>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="form-group">
                                            <input className="form-control" id="phone" name="phone" value={phone} onChange={(e) => handleChange(e)} placeholder="Phone" type="text" />
                                            <span className="alert-error"></span>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="form-group comments">
                                            <textarea className="form-control" id="comments" name="comments" value={comments} onChange={(e) => handleChange(e)} placeholder="Tell us about your job interest/ questions/ requests *"></textarea>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-12">
                                        <button type="submit" name="submit" id="submit">
                                            Send Message <i className="fa fa-paper-plane"></i>
                                        </button>
                                    </div>
                                </div>

                                <div className="col-lg-12 alert-notification">
                                    <div id="message" className="alert-msg"></div>
                                </div>
                                <br />

                                {validationError ?
                                <div className="alert alert-error alert-warning">{validationMessage}</div> : <></>}

                                {success ?
                                <div className='alert alert-success'>
                                  <h3>Email Sent Successfully.</h3>
                                  <p>Thank you, your message has been submitted to us.</p>
                                </div> : <></>}

                                {failure ?
                                <div className='alert alert-danger'>
                                  <h3>Error Sending Email.</h3>
                                  <p>An error has occured while sending this message. Please email us to resolve the issue.</p>
                                </div> : <></>}
                            </form>
                        </div>
                    </div>

                    <div className="col-lg-4 right-item">
                        <div className="info-items">

                            <div className="item">
                                <div className="icon">
                                    <i className="flaticon-location-1"></i>
                                </div>
                                <div className="info">
                                    <h5>Location</h5>
                                    <p>
                                      <a href='https://maps.google.com/?q=101 Brady Court, Suite B, Cary, NC 27511'>
                                        101 Brady Court, Suite B, Cary, NC 27511
                                      </a>
                                    </p>
                                </div>
                            </div>

                            <div className="item">
                                <div className="icon">
                                    <i className="flaticon-call"></i>
                                </div>
                                <div className="info">
                                    <h5>Make a call / Fax number</h5>
                                    <p>
                                        Tel: <a href="tel:9199721964">919 972 1964</a> / Fax: 984 465 0694
                                    </p>
                                </div>
                            </div>

                            <div className="item">
                                <div className="icon">
                                    <i className="flaticon-email"></i>
                                </div>
                                <div className="info">
                                    <h5>Send a Mail</h5>
                                    <p>
                                      <a href = "mailto:divine@divinechpstaffing.com">divine@divinechpstaffing.com</a>
                                    </p>
                                </div>
                            </div>

                            <div className="item">
                                <div className="icon">
                                    <i className="flaticon-clock-1"></i>
                                </div>
                                <div className="info">
                                    <h5>Opening Hours</h5>
                                    <p>
                                        Mon - Fri : <span>8:00am - 4:30pm</span><br />
                                        Sat : <span>9:00am - 2:00pm</span>
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
    </>
  );
}

export default Contact;